/* eslint eqeqeq: 0 */
import React, { useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useTranslation } from "react-i18next";
import { changeMode, isDarkMode } from "../../../redux/Theme";
import { useDispatch, useSelector } from "react-redux";

const LanguageSelector = ({ login, isLogin, setIsloggedIn }) => {
  const [lang, setLang] = useState("en");
  const { t, i18n } = useTranslation();
  const darkMode = useSelector(isDarkMode);

  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang) {
      setLang(
        storedLang === "en" || storedLang === "en-US" ? "en" : storedLang
      );
    }
  }, [lang]);

  const changeLanguage = (lng: string) => {
    localStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
    setLang(lng);
  };

  let navDropdownTitle = '';
  const selectedLanguage = localStorage.getItem("language");
  const textColor = darkMode? 'text-white' : 'text-dark';

  if (selectedLanguage == '') {
    navDropdownTitle = (
      <span onclick="" className={`pl-0 pr-0 dropdown-item has-icon d-inline bg-transparent ${textColor}`}>
          <svg style={{marginBottom: '4px'}} width="30" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="IcFlagRectangleGlobal">
            <rect x="1" y="4" width="22" height="16" rx="1" fill="#0A9AF2"></rect>
            <path d="M17.7193 12.2517C17.7022 15.2885 15.2266 17.7364 12.1898 17.7193M17.7193 12.2517C17.7364 9.215 15.2885 6.73937 12.2517 6.72228M17.7193 12.2517L6.72228 12.1899M12.1898 17.7193C9.1531 17.7022 6.70519 15.2266 6.72228 12.1899M12.1898 17.7193L12.2517 6.72228M12.1898 17.7193C16.1282 15.1256 16.1606 9.36011 12.2517 6.72228M12.1898 17.7193C8.28094 15.0815 8.31339 9.31595 12.2517 6.72228M6.72228 12.1899C6.73937 9.15311 9.21499 6.70519 12.2517 6.72228" stroke="white" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          EN
      </span>
    );
  } else {
    if (selectedLanguage == 'en') {
      navDropdownTitle = (
        <span onclick="" className={`pl-0 pr-0 dropdown-item has-icon d-inline bg-transparent ${textColor}`}>
            <svg style={{marginBottom: '4px'}} width="30" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="IcFlagRectangleGlobal">
              <rect x="1" y="4" width="22" height="16" rx="1" fill="#0A9AF2"></rect>
              <path d="M17.7193 12.2517C17.7022 15.2885 15.2266 17.7364 12.1898 17.7193M17.7193 12.2517C17.7364 9.215 15.2885 6.73937 12.2517 6.72228M17.7193 12.2517L6.72228 12.1899M12.1898 17.7193C9.1531 17.7022 6.70519 15.2266 6.72228 12.1899M12.1898 17.7193L12.2517 6.72228M12.1898 17.7193C16.1282 15.1256 16.1606 9.36011 12.2517 6.72228M12.1898 17.7193C8.28094 15.0815 8.31339 9.31595 12.2517 6.72228M6.72228 12.1899C6.73937 9.15311 9.21499 6.70519 12.2517 6.72228" stroke="white" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            EN
        </span>
      );
    } else if(selectedLanguage == 'id') {
      navDropdownTitle = (
        <span onclick="" className={`pl-0 pr-0 dropdown-item has-icon d-inline bg-transparent ${textColor}`}>
            <svg style={{marginBottom: '4px'}} width="30" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="IcFlagRectangleId">
              <rect x="0.75" y="3.75" width="22.5" height="16.5" rx="1.25" fill="white" stroke="#C1C4C6" stroke-width="0.5"></rect>
              <path d="M1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V12H1V5Z" fill="#E70011"></path>
            </svg>
            ID
        </span>
      );
    } else {
      navDropdownTitle = (
        <span onclick="" className={`pl-0 pr-0 dropdown-item has-icon d-inline bg-transparent ${textColor}`}>
            <svg style={{marginBottom: '4px'}} width="30" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="IcFlagRectangleId">
              <rect x="0.75" y="3.75" width="22.5" height="16.5" rx="1.25" fill="white" stroke="#C1C4C6" stroke-width="0.5"></rect>
              <path d="M1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V12H1V5Z" fill="#E70011"></path>
            </svg>
            {selectedLanguage}
        </span>
      );
    }
  }

  return (
    <Navbar variant="light" bg="transparent" expand="sm" className="language-selector">
      <Container fluid className={"p-0"}>
        <Navbar.Toggle aria-controls="navbar-dark-example" />
        <Navbar.Collapse id="navbar-dark-example">
          <Nav>
            <NavDropdown
              id="nav-dropdown-dark-example"
              title={navDropdownTitle}
              menuVariant={darkMode? "dark" : "light"}
            >
              <NavDropdown.Item href="javascript:void(0);" onClick={() => changeLanguage("id")}>
                <span onclick="" className={`dropdown-item has-icon ${textColor}`}>
                    <svg style={{marginBottom: '4px'}} width="30" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="IcFlagRectangleId">
                      <rect x="0.75" y="3.75" width="22.5" height="16.5" rx="1.25" fill="white" stroke="#C1C4C6" stroke-width="0.5"></rect>
                      <path d="M1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V12H1V5Z" fill="#E70011"></path>
                    </svg>
                    Bahasa Indonesia
                </span>
              </NavDropdown.Item>
              <NavDropdown.Item href="javascript:void(0);" onClick={() => changeLanguage("en")}>
                <span onclick="" className={`dropdown-item has-icon ${textColor}`}>
                    <svg style={{marginBottom: '4px'}} width="30" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="IcFlagRectangleGlobal">
                      <rect x="1" y="4" width="22" height="16" rx="1" fill="#0A9AF2"></rect>
                      <path d="M17.7193 12.2517C17.7022 15.2885 15.2266 17.7364 12.1898 17.7193M17.7193 12.2517C17.7364 9.215 15.2885 6.73937 12.2517 6.72228M17.7193 12.2517L6.72228 12.1899M12.1898 17.7193C9.1531 17.7022 6.70519 15.2266 6.72228 12.1899M12.1898 17.7193L12.2517 6.72228M12.1898 17.7193C16.1282 15.1256 16.1606 9.36011 12.2517 6.72228M12.1898 17.7193C8.28094 15.0815 8.31339 9.31595 12.2517 6.72228M6.72228 12.1899C6.73937 9.15311 9.21499 6.70519 12.2517 6.72228" stroke="white" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    English (International)
                </span>
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default LanguageSelector;
